export const THEME_PREFERENCES = ["system", "light", "dark"] as const;
export type ThemePreference = (typeof THEME_PREFERENCES)[number];

export const THEME_PREFERENCE_ICONS: Record<ThemePreference, string> = {
	system: "theme-light-dark",
	light: "white-balance-sunny",
	dark: "weather-night",
};

const THEME_PREFERENCE_SET: ReadonlySet<string> = new Set(THEME_PREFERENCES);

export const isThemePreference = (value: unknown): value is ThemePreference =>
	typeof value === "string" && THEME_PREFERENCE_SET.has(value);
